module.exports = __webpack_public_path__ + "static/media/Online-Brand-Development@2x.6f9ffc70.png";